import { Stack } from "@mui/material";
import { Outlet } from "react-router-dom";
import { usePatient } from "src/context/PatientProvider";
import PatientDemographics from "src/components/PatientDemographics";
import MentalHealthScoreChip from "src/components/MentalHealthScoreChip";

const PatientLayout = () => {
  const patient = usePatient((p) => p);

  return (
    <Stack width="100%" gap={3} height={window.innerHeight - 32}>
      <Stack spacing={1.5}>
        <PatientDemographics patient={patient} />
        <MentalHealthScoreChip patientId={patient.id} />
      </Stack>
      <Outlet />
    </Stack>
  );
};

export default PatientLayout;
